module.exports = __webpack_public_path__ + "media/images/icon__smallInfoBox@3x-d96200e04c95cf16dc2bea1e1a63f2d4.png";